export const PHONE = "+14375571041";
export const WHATSAPP_URL = "https://wa.me/14375571041";

export const IMG = {
  dietitian: "/team/manthan.jpg",
  manthan: "/team/manthan.jpg",
  ankita: "/team/ankita.jpg",
  // Professional, portion-controlled dietitian-style food photography (not restaurant/dhaba)
  food: "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?auto=format&fit=crop&w=1200&q=85", // clean grain bowl
  mealprep: "https://images.unsplash.com/photo-1490645935967-10de6ba17061?auto=format&fit=crop&w=1200&q=85", // meal prep containers
  bowl: "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?auto=format&fit=crop&w=1200&q=85", // portion plate
  buddha: "https://images.unsplash.com/photo-1490474418585-ba9bad8fd0ea?auto=format&fit=crop&w=1200&q=85", // buddha bowl
  travel: "https://images.unsplash.com/photo-1490645935967-10de6ba17061?auto=format&fit=crop&w=1200&q=85", // meal prep travel
};

// Deterministic initial-based avatar keyed to name — guarantees no gender mismatch.
export function avatarFor(name) {
  const encoded = encodeURIComponent(name);
  return `https://ui-avatars.com/api/?name=${encoded}&background=EDF054&color=0F4046&bold=true&size=200&font-size=0.42`;
}
